import React from 'react';

import { Link } from 'react-router-dom';
import Button from '../../../artzu-ui/src/Button';
import teslaTop from '../../../images/teslaTop.png';

const AutzuEv = ({ location }) => (
  <div className="landing__section grey-background nyc-vehicle-types--desktop">
    <div className="container section-1__display">
      <div
        className="nyc-vehicle-types__column--plus"
        style={{ left: '0' }}>
        <h1 className="nyc-vehicle-types__header">Autzu EV</h1>
        <p className="nyc-vehicle-types__text nyc-vehicle-types__text--small">
          Starting at
        </p>
        <h4 className="nyc-vehicle-types__subheader nyc-vehicle-types__subheader--plus">
          <div className="nyc-vehicle-types__subheader--rate">$7</div>
          <div className="nyc-vehicle-types__subheader--hr">/hr</div>
        </h4>
        <div className="section-1__reasons-container">
          <div className="section-1__reasons-single">
            <h4 className="section-1__header section-1__header--medium section-1__header--medium--nyc">
              What's included
            </h4>
            <p className="section-1__text section-1__text--blurb section-1__text--margin-right section-1__text--nyc">
              Unlimited Mileage <br />
              Full Maintenance <br />
              Comprehensive Insurance <br />
              Roadside Assistance <br />
              24/7 Emergency Support
            </p>
          </div>
          <div className="section-1__reasons-single">
            <h4 className="section-1__header  section-1__header--medium section-1__header--medium--nyc">
              Vehicles
            </h4>
            <p className="section-1__text section-1__text--blurb section-1__text--margin-right section-1__text--nyc">
              Tesla Model 3
            </p>
          </div>
          <div className="section-1__reasons-single">
            <Link
              className="section-1__link section-1__button--learn-more autzu-go__desktop__learn-more"
              to={`/${location}/ev`}>
              <Button
                label="Learn More"
                color="#414141"
                size="xl"
                className=""
              />
            </Link>
          </div>
        </div>
      </div>

      <div
        className="section-1__display--right"
        style={{ width: '300px', justifyContent: 'center' }}>
        <img
          className="section-1__car--image--sfLanding"
          alt="heading tesla"
          src={teslaTop}
        />
      </div>
    </div>
  </div>
);

export default AutzuEv;



// WEBPACK FOOTER //
// ./src/components/Static/UberToronto/AutzuEvSF.js